import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clone as t } from "../../../../../core/lang.js";
import { urlToObject as e, isAbsolute as i, join as l, addQueryParameters as r } from "../../../../../core/urlUtils.js";
import s from "../../../../../geometry/Extent.js";
import { readServiceTileInfo as o } from "../../../../../layers/support/serviceTileInfoProperty.js";
import { TilemapCache as n } from "../../../../../layers/support/TilemapCache.js";
import a from "../TilemapIndex.js";
import p from "../TilemapRequest.js";

var u = /*#__PURE__*/function () {
  function u(_u, h, c) {
    _classCallCheck(this, u);

    this.tilemap = null, this.tileInfo = null, this.capabilities = null, this.fullExtent = null, this.name = _u, this.sourceUrl = h;
    var m = e(this.sourceUrl),
        f = t(c),
        d = f.tiles;
    if (m) for (var _t = 0; _t < d.length; _t++) {
      var _s = e(d[_t]);

      _s && (i(_s.path) || (_s.path = l(m.path, _s.path)), d[_t] = r(_s.path, _objectSpread(_objectSpread({}, m.query), _s.query)));
    }
    this.tileServers = d;
    var g = c.capabilities && c.capabilities.split(",").map(function (t) {
      return t.toLowerCase().trim();
    }),
        x = !0 === (null == c ? void 0 : c.exportTilesAllowed),
        y = !0 === (null == g ? void 0 : g.includes("tilemap")),
        v = x && c.hasOwnProperty("maxExportTilesCount") ? c.maxExportTilesCount : 0;
    this.capabilities = {
      operations: {
        supportsExportTiles: x,
        supportsTileMap: y
      },
      exportTiles: x ? {
        maxExportTilesCount: +v
      } : null
    }, this.tileInfo = o(f.tileInfo, f, null, {
      ignoreMinMaxLOD: !0
    });
    var T = c.tileMap ? r(l(m.path, c.tileMap), m.query) : null;
    y ? (this.type = "vector-tile", this.tilemap = new p(new n({
      layer: {
        parsedUrl: m,
        tileInfo: this.tileInfo,
        type: "vector-tile",
        tileServers: this.tileServers
      }
    }), T)) : T && (this.tilemap = new a(T)), this.fullExtent = s.fromJSON(c.fullExtent);
  }

  _createClass(u, [{
    key: "getRefKey",
    value: function () {
      var _getRefKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e) {
        var i, l;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", null != (i = null == (l = this.tilemap) ? void 0 : l.dataKey(t, e)) ? i : t);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRefKey(_x, _x2) {
        return _getRefKey.apply(this, arguments);
      }

      return getRefKey;
    }()
  }, {
    key: "getSourceTileUrl",
    value: function getSourceTileUrl(t, e, i) {
      return this.tileServers[e % this.tileServers.length].replace(/\{z\}/gi, t.toString()).replace(/\{y\}/gi, e.toString()).replace(/\{x\}/gi, i.toString());
    }
  }, {
    key: "isCompatibleWith",
    value: function isCompatibleWith(t) {
      var e = this.tileInfo,
          i = t.tileInfo;
      if (!e.spatialReference.equals(i.spatialReference)) return !1;
      if (!e.origin.equals(i.origin)) return !1;
      if (Math.round(e.dpi) !== Math.round(i.dpi)) return !1;
      var l = e.lods,
          r = i.lods,
          s = Math.min(l.length, r.length);

      for (var _o = 0; _o < s; _o++) {
        var _t2 = l[_o],
            _e = r[_o];
        if (_t2.level !== _e.level || Math.round(_t2.scale) !== Math.round(_e.scale)) return !1;
      }

      return !0;
    }
  }]);

  return u;
}();

export { u as default };